module.exports = __webpack_public_path__ + "static/media/welcome-to-jrnl.81ed16a3.png";